import AsyncStorage from '@react-native-async-storage/async-storage';
import { InitialState } from '@react-navigation/native';
import type { LoginResponseReturnData } from '~/api-services/AuthDataService/types';
import type { AppSettings } from './reducers/appSettingsSlice';
import type { News } from '~/api-services/NewsService/types';

class LocalStorageSlice<T> {
    constructor(private key: string) {}

    public async set(data: T) {
        await AsyncStorage.setItem(this.key, JSON.stringify(data));
        return data;
    }

    public async get() {
        const data = await AsyncStorage.getItem(this.key);

        if (!data) {
            return null;
        }

        const parsedData: T = JSON.parse(data);

        return parsedData;
    }

    public async clear() {
        await AsyncStorage.removeItem(this.key);
    }
}

export default {
    userAuthData: new LocalStorageSlice<LoginResponseReturnData>('user_auth_data'),
    appSettings: new LocalStorageSlice<AppSettings>('app_settings'),
    initialNavigationState: new LocalStorageSlice<InitialState>('navigation_state'),
    news: new LocalStorageSlice<News[]>('news'),
    // Which one-off intros the user has already been shown, as feature key -> content version.
    // A version rather than a boolean so a materially rewritten intro can be shown again by
    // bumping one constant. Device-scoped: unlike userAuthData it is not cleared on logout,
    // because it describes the product rather than the account.
    onboarding: new LocalStorageSlice<Record<string, number>>('onboarding_seen'),
    // Terms-of-business declarations for automated strategies, as account key -> accepted version.
    // Account-scoped rather than device-scoped: the declaration is made by a person, so a second
    // user on the same device makes their own. Deliberately survives logout, so returning users
    // are not asked again.
    strategyConsent: new LocalStorageSlice<Record<string, number>>('strategy_consent'),
};
